import React, { useState, useEffect } from "react";
import { DataStore } from "@aws-amplify/datastore";
import { Card, Button } from "react-bootstrap";
import { VehicleModelGeneralInfo } from "../models";

function Suggestions({ suggestions, onSuggestionSelect }) {
  return (
    <div className="disappear card mx-auto d-flex flex-column justify-content-between">
      {suggestions.map((suggestion, index) => (
        <div
          key={index}
          className="suggestion-item"
          onClick={() => onSuggestionSelect(suggestion)}
        >
          {suggestion.Manufacturer} {suggestion.ModelName}
        </div>
      ))}
    </div>
  );
}

export default function Cars() {
  const [cars, setCars] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCar, setSelectedCar] = useState(null);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  useEffect(() => {
    const searchInput = document.querySelector(".search-input");
    const suggestionsList = document.querySelector(".disappear");

    function handleClickOutside(event) {
      if (searchInput && !searchInput.contains(event.target) && suggestionsList && !suggestionsList.contains(event.target)) {
        setFilteredSuggestions([]);
      }
    }

    // Attach the listener to the document
    document.addEventListener("click", handleClickOutside);

    // Cleanup the listener when the component is unmounted
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    fetchCars();
  }, []);

  async function fetchCars() {
    try {
      const fetchedCars = await DataStore.query(VehicleModelGeneralInfo);
      console.log(fetchedCars);
      setCars(fetchedCars);
    } catch (error) {
      console.error("Error fetching cars:", error);
    }
  }

  function filterCars(car, searchQuery) {
    const words = searchQuery.toLowerCase().split(" ");
    return (
      car.VehicleType === "CAR" &&
      car.Manufacturer &&
      car.ModelName &&
      words.every(
        (word) =>
          car.Manufacturer.toLowerCase().includes(word) ||
          car.ModelName.toLowerCase().includes(word)
      )
    );
  }

  function handleInputChange(event) {
    const query = event.target.value;
    setSearchQuery(query);
    const suggestions = cars.filter((car) => filterCars(car, query));
    setFilteredSuggestions(suggestions);
  }

  function handleSuggestionSelect(suggestion) {
    setSelectedCar(suggestion);
    setFilteredSuggestions([]); // Clear suggestions
  }

  function toggleSuggestions() {
    // If suggestions are already displayed, hide them.
    // If they're not displayed, show them (based on the cars list).
    if (filteredSuggestions.length > 0) {
      setFilteredSuggestions([]);
    } else {
      const carsOnly = cars.filter(car => car.VehicleType === "CAR");
      setFilteredSuggestions(carsOnly);
    }
  }

  return (
    <div style={{ position: "relative" }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <input
          className="search-input card mx-auto d-flex flex-column justify-content-between"
          type="text"
          placeholder="Click here to see cars or search car models..."
          value={searchQuery}
          onChange={handleInputChange}
          onClick={toggleSuggestions}
          style={{ padding: "10px", marginBottom: "5px" }}
        />

        {filteredSuggestions.length > 0 && (
          <Suggestions
            suggestions={filteredSuggestions}
            onSuggestionSelect={handleSuggestionSelect}
          />
        )}
      </div>

      {selectedCar && (
        <div className="homepageCarousel">
          <Card className="card mx-auto d-flex flex-column justify-content-between">
            <div>
              <Card.Img
                variant="top"
                src={selectedCar.Picture}
                alt={`Slide Car`}
                className="card-image"
              />
              <Card.Body className="card-body"
                style={{ maxHeight: "400px", overflowY: "auto" }}>
                <h4 className="card-title">
                  {selectedCar.Manufacturer} {selectedCar.ModelName}
                </h4>
                <div className="card-info">
                  <p>
                    <strong>Vehicle Type:</strong> {selectedCar.VehicleType}
                  </p>
                  <p>
                    <strong>Manufacturer:</strong> {selectedCar.Manufacturer}
                  </p>
                  <p>
                    <strong>Model Name:</strong> {selectedCar.ModelName}
                  </p>
                  <p>
                    <strong>Body Style:</strong> {selectedCar.BodyStyle}
                  </p>
                  <p>
                    <strong>Engine Type:</strong> {selectedCar.EngineType}
                  </p>
                  <p>
                    <strong>Transmission:</strong> {selectedCar.Transmission}
                  </p>
                  <p>
                    <strong>Drivetrain:</strong> {selectedCar.Drivetrain}
                  </p>
                  <p>
                    <strong>Acceleration:</strong> {selectedCar.Acceleration}
                  </p>
                  <p>
                    <strong>Top Speed:</strong> {selectedCar.TopSpeed}
                  </p>
                  <p>
                    <strong>Fuel Economy:</strong> {selectedCar.FuelEconomy}
                  </p>
                  <p>
                    <strong>General Information:</strong> {selectedCar.Information}
                  </p>

                </div>

              </Card.Body>

            </div>
          </Card>
        </div>
      )}
    </div>
  );
}

